/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Onboarding_Source_TitleInputs */

const en_ui_onboarding_source_title = /** @type {(inputs: Ui_Onboarding_Source_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Where are your sessions?`)
};

const de_ui_onboarding_source_title = /** @type {(inputs: Ui_Onboarding_Source_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wo liegen deine Einheiten?`)
};

/**
* | output |
* | --- |
* | "Where are your sessions?" |
*
* @param {Ui_Onboarding_Source_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_onboarding_source_title = /** @type {((inputs?: Ui_Onboarding_Source_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Onboarding_Source_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_onboarding_source_title(inputs)
	return de_ui_onboarding_source_title(inputs)
});